import { FunctionComponent } from 'react'
import Link from '../Link/Link'

type BreadcrumbItem = ({
  id?: number | null | undefined
  url?: string | null | undefined
  name?: string | null | undefined
} | null)[]

type BreadCrumbProps = {
  className?: string
  name?: string
  breadcrumbs?: BreadcrumbItem
}

const BreadCrumb: FunctionComponent<BreadCrumbProps> = ({ className, name, breadcrumbs }) => (
  <div className={`breadcrumbs ${className ?? ''}`}>
    <ul>
      <li>
        <Link href={`/` ?? undefined} className='underline'>
          Messika
        </Link>
      </li>

      {breadcrumbs?.map((item) => (
        <li key={item?.id}>
          <Link href={item?.url ?? ''} className='underline'>
            {item?.name}
          </Link>
        </li>
      ))}

      {name && (
        <li>
          <span>{name}</span>
        </li>
      )}
    </ul>
  </div>
)

export default BreadCrumb
